<template>


    <div>
        <div class="row">

            <div class="col-md-12">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link :to="{ name: 'home' }">{{ $t("inicio") }}</router-link>
                        </li>
                        <li class="breadcrumb-item">
                            <router-link :to="{ name: 'almacen' }">{{ $t("almacen") }}</router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">
                            <router-link :to="{ name: 'historial-almacen' }">{{ $t("historialAlmacen") }}</router-link>
                        </li>

                        <li class="breadcrumb-item active" aria-current="page">{{ $t("detalleAlmacen") }}</li>
                    </ol>
                </nav>
            </div>


            <div class="col-md-12">
                <div class="card">
                    <h3 v-if="nombreTpv != ''"><strong>{{ nombreTpv }}</strong></h3>
                    <h3>{{ detalles.date | parseDate }} - <span v-if="detalles.tipo === 'E'">{{ $t("entrada") }} -
                            {{ $t("factura") }}:</span><span v-else-if="detalles.tipo === 'I'">{{ $t("inventario")
                            }}:</span><span v-else>{{ $t("salida") }} -
                            {{ $t("factura") }}:</span> {{ detalles.reference }}</h3>

                    <div class="col-md-12 col-xs-12 text-right">
                        <el-dropdown>
                            <el-button type="primary" size="small">
                                <i class="fa fa-file"></i>
                                {{ $t("exportarInforme") }} <i class="el-icon-arrow-down el-icon--right"></i>
                            </el-button>

                            <el-dropdown-menu slot="dropdown">

                                <a :href="urlExportPDF">
                                    <el-dropdown-item class="text-danger">
                                        <strong><i class="fa fa-file-pdf" style="color: red"></i>
                                            {{ $t("exportarPdf") }}</strong>
                                    </el-dropdown-item>
                                </a>
                                <a :href="urlExportExcel">
                                    <el-dropdown-item class="text-success">
                                        <strong><i class="fa fa-file-excel" style="color: green"></i>
                                            {{ $t("exportarExcel") }}</strong>
                                    </el-dropdown-item>
                                </a>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>

                    <template v-if="listSubproduct.length > 0">
                        <div class="row justify-content-between div-export">

                        </div>

                        <div>
                            <table class="table table-bordered table-striped tableHeader-responsive"
                                style="overflow: auto">
                                <thead class="thead-dark">
                                    <th>{{ $t("totalValoresRecuento") }}</th>
                                    <td align="center"><strong>{{ calculateValorRecuento | currency }}</strong></td>
                                    <th>{{ $t("totalValoresDiferencia") }}</th>
                                    <td align="center"><strong>{{ calculateValorDiferencia | currency }}</strong></td>
                                    <th>{{ $t("totalValoresDto") }}</th>
                                    <td align="center"><strong>{{ calculateValorDto | currency }}</strong></td>
                                    <th v-if="detalles.tipo === 'I'">{{ $t("totalValoresNegativos") }}</th>
                                    <td align="center"><strong>{{ calculateNegativeValues | currency }}</strong></td>
                                </thead>
                            </table>
                        </div>

                        <div class="table-responsive" style="overflow: auto" v-for="s in listSubproduct">
                            <strong>{{ s.nameTag }}</strong>
                            <table class="table table-bordered table-striped">
                                <thead class="thead-dark">
                                    <tr>
                                        <th>{{ $t("nombre") }}</th>
                                        <th>
                                            <template v-if="detalles.tipo === 'I'">{{ $t("existenciasTeoricas")
                                                }}</template>
                                            <template v-else-if="detalles.tipo === 'S'">{{ $t("salida") }}</template>
                                            <template v-else>{{ $t("entrada") }}</template>
                                        </th>
                                        <th v-if="detalles.tipo === 'I'">{{ $t("recuento") }}</th>
                                        <th v-if="detalles.tipo === 'I'">{{ $t("valorRecuento") }}</th>
                                        <th v-if="detalles.tipo === 'I'">{{ $t("diferencia") }}</th>
                                        <th v-if="detalles.tipo === 'I'">{{ $t("valorDiferencia") }}</th>
                                        <th v-else>{{ $t("valor") }}</th>
                                        <th v-if="detalles.tipo === 'I'">{{ $t("valorDifereciaDto") }}</th>
                                        <th v-else>{{ $t("valorDto") }}</th>
                                    </tr>
                                </thead>
                                <tbody>

                                    <tr :class="sub.color" v-for="sub in s.subproducts">
                                        <td>{{ sub.nameSub }}<br>
                                            <span style="font-size:0.9em; color: #757272">({{ sub.type }} -
                                                {{ $t("escandallo") }}:
                                                {{ sub.escandallo }})</span>
                                        </td>
                                        <td>
                                            <span v-if="parseInt(sub.escandallo) !== 1">{{ sub.unidades }} /
                                                {{ sub.partes }}</span><span v-else>{{ sub.unidades }}
                                            </span>
                                        </td>
                                        <td v-if="detalles.tipo === 'I'"><!-- RECUENTO -->
                                            <template v-if="parseInt(detalles.complete) === 0">{{ $t("noContabilizado")
                                                }}
                                            </template>

                                            <template v-else>
                                                <template v-if="sub.escandallo != 1">
                                                    {{ sub.unidadesRelleno }} / {{ sub.partesRelleno }}
                                                </template>
                                                <template v-else>
                                                    {{ sub.unidadesRelleno }}
                                                </template>
                                            </template>
                                        </td>
                                        <td v-if="detalles.tipo === 'I'">
                                            <template v-if="parseInt() === 0">
                                                {{ $t("noContabilizado") }}
                                            </template>
                                            <template>

                                                <template class="text-success"
                                                    v-if="sub.unidadesRelleno >= 0 && sub.partesRelleno >= 0">
                                                    {{ (sub.unidadesRelleno + (sub.partesRelleno / sub.escandallo)) *
                                                        parseFloat(sub.precioCompra / (1 + sub.iva / 100)) | currency }}
                                                </template>
                                                <template class="text-danger" v-else>
                                                    valor recuento negativo
                                                </template>

                                            </template>

                                        </td>
                                        <td v-if="detalles.tipo === 'I'">
                                            <template v-if="parseInt(detalles.complete) === 0">{{ $t("noContabilizado")
                                                }}
                                            </template>
                                            <template class="text-success" v-else>
                                                <template v-if="sub.escandallo != 1">
                                                    {{ sub.diferenciaUnidades }} / {{ sub.diferenciaPartes }}
                                                </template>
                                                <template v-else>
                                                    {{ sub.diferenciaUnidades }}
                                                </template>
                                            </template>
                                        </td>

                                        <td><!-- VALOR -->
                                            <template v-if="detalles.tipo === 'I'">
                                                <!--<template v-if="sub.diferenciaUnidades<0 || sub.diferenciaPartes<0">
                                                {{ 0| currency}}
                                            </template>-->
                                                <template><!-- v-else -->
                                                    {{ (sub.diferenciaUnidades + sub.diferenciaPartes / sub.escandallo)
                                                        *
                                                        parseFloat(sub.precioCompra / (1 + sub.iva / 100)) | currency }}
                                                </template>
                                            </template>
                                            <template v-else> {{ (sub.unidades + sub.partes / sub.escandallo) *
                                                parseFloat(sub.precioCompra / (1 + sub.iva / 100))
                                                | currency }}
                                            </template>
                                        </td>

                                        <td><!-- VALOR DTO. -->
                                            <template v-if="detalles.tipo === 'I'">
                                                <!--<template v-if="sub.diferenciaUnidades<0 || sub.diferenciaPartes<0">
                                                {{0| currency}}
                                            </template>-->
                                                <template><!-- v-else -->
                                                    {{ (sub.diferenciaUnidades + sub.diferenciaPartes / sub.escandallo)
                                                        *
                                                        parseFloat(sub.precioCompra / (1 + sub.iva / 100)) -
                                                        ((sub.diferenciaUnidades + sub.diferenciaPartes / sub.escandallo) *
                                                            parseFloat(sub.precioCompra / (1 + sub.iva / 100)) *
                                                            parseFloat(sub.dto) / 100) | currency }}

                                                </template>
                                            </template>
                                            <template v-else>
                                                {{ (sub.unidades + sub.partes / sub.escandallo) *
                                                    parseFloat(sub.precioCompra
                                                        / (1 + sub.iva / 100)) -
                                                    ((sub.unidades + sub.partes / sub.escandallo) *
                                                        parseFloat(sub.precioCompra
                                                            / (1 + sub.iva / 100)) *
                                                        parseFloat(sub.dto) / 100) | currency }}
                                            </template>
                                        </td>

                                    </tr>


                                </tbody>
                                <tfoot>
                                    <tr class="table-success">
                                        <td><strong>{{ $t("total") }}</strong></td>
                                        <td></td>
                                        <template v-if="detalles.tipo === 'I'">
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                        </template>
                                        <td>
                                            <strong>
                                                {{ getTotalValor(s) | currency }}
                                            </strong>
                                            <i v-tooltip.top-center="$t('solamenteSeTieneEnCuentaValoresPositivos')
                                                " class="fa fa-question-circle"></i>
                                        </td>
                                        <td>
                                            <strong>
                                                {{ getTotalValorDto(s) | currency }}
                                            </strong>
                                            <i v-tooltip.top-center="$t('solamenteSeTieneEnCuentaValoresPositivos')
                                                " class="fa fa-question-circle"></i>
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>

                    </template>
                    <template v-else>
                        <div class="alert alert-danger" role="alert">
                            {{ $t("noHayDatosEnEsteMovimientoDeAlmacen") }}.
                        </div>
                    </template>

                    <div class="col-md-12 text-right">
                        <label>&nbsp;</label>
                        <div class="form-group">
                            <router-link :to="{ name: 'historial-almacen' }">
                                <button class="btn btn-danger"><i class="fa fa-refresh"></i>
                                    {{ $t("volver") }}
                                </button>
                            </router-link>
                        </div>
                    </div>

                </div>
            </div>


        </div>


    </div>


</template>

<script>
import { Dropdown, DropdownItem, DropdownMenu, Button } from 'element-ui'
import moment from 'moment'

export default {
    name: "DetallesAlmacen",
    components: {
        [Dropdown.name]: Dropdown,
        [DropdownItem.name]: DropdownItem,
        [DropdownMenu.name]: DropdownMenu,
        [Button.name]: Button,
    },
    data() {
        return {
            idAlmacen: this.$route.params.idAlmacen,
            idBusiness: this.$route.params.idBusiness,
            nombreTpv: this.$route.params.nombreTpv ? this.$route.params.nombreTpv : "",
            listSubproduct: [''],
            detalles: '',
            totalValores: 0,
            totalValoresDto: 0,
        }

    },
    computed: {

        calculateValorRecuento() {
            let total = 0;
            let vm = this;

            if (this.listSubproduct && Array.isArray(this.listSubproduct)) {
                this.listSubproduct.forEach(function (xcat) {
                    if (xcat && xcat.subproducts && Array.isArray(xcat.subproducts)) {
                        xcat.subproducts.forEach(function (sub) {
                            if (sub && sub.precioCompra != null && sub.iva != null) {
                                if (vm.detalles && vm.detalles.tipo === 'I') {
                                    if (sub.unidadesRelleno > 0 || sub.diferenciaPartes > 0) {
                                        sub.escandallo > 0
                                            ? total += (sub.unidadesRelleno + sub.diferenciaPartes / sub.escandallo) * parseFloat(sub.precioCompra / (1 + sub.iva / 100))
                                            : total += sub.unidadesRelleno * parseFloat(sub.precioCompra / (1 + sub.iva / 100));
                                    }
                                } else {
                                    sub.escandallo > 0
                                        ? total += (sub.unidades + sub.partes / sub.escandallo) * parseFloat(sub.precioCompra / (1 + sub.iva / 100))
                                        : total += sub.unidades * parseFloat(sub.precioCompra / (1 + sub.iva / 100));
                                }
                            }
                        });
                    }
                });
            }
            return total;
        },

        calculateValorDiferencia() {

            let total = 0;
            let vm = this;

            if (this.listSubproduct && Array.isArray(this.listSubproduct)) {
                this.listSubproduct.forEach(function (xcat) {

                    if (xcat && xcat.subproducts && Array.isArray(xcat.subproducts)) {
                        xcat.subproducts.forEach(function (sub) {

                            if (vm.detalles.tipo === 'I') {

                                if (sub.diferenciaUnidades > 0 || sub.diferenciaPartes > 0) {
                                    sub.escandallo > 0
                                        ? total += (sub.diferenciaUnidades + sub.diferenciaPartes / sub.escandallo) * parseFloat(sub.precioCompra / (1 + sub.iva / 100))
                                        : total += sub.diferenciaUnidades * parseFloat(sub.precioCompra / (1 + sub.iva / 100));
                                }

                            } else {

                                sub.escandallo > 0
                                    ? total += (sub.unidades + sub.partes / sub.escandallo) * parseFloat(sub.precioCompra / (1 + sub.iva / 100))
                                    : total += sub.unidades * parseFloat(sub.precioCompra / (1 + sub.iva / 100));

                            }
                        });
                    }
                });
            }

            return total;
        },

        calculateValorDto() {

            let total = 0;
            let vm = this;

            if (this.listSubproduct && Array.isArray(this.listSubproduct)) {
                this.listSubproduct.forEach(function (xcat) {
                    if (xcat && xcat.subproducts && Array.isArray(xcat.subproducts)) {
                        xcat.subproducts.forEach(function (sub) {
                            if (sub && sub.precioCompra != null && sub.iva != null && sub.dto != null) {
                                if (vm.detalles && vm.detalles.tipo === 'I') {
                                    if (sub.diferenciaUnidades > 0 || sub.diferenciaPartes > 0) {
                                        sub.escandallo > 0
                                            ? total += (sub.diferenciaUnidades + sub.diferenciaPartes / sub.escandallo) * parseFloat(sub.precioCompra / (1 + sub.iva / 100)) -
                                            ((sub.diferenciaUnidades + sub.diferenciaPartes / sub.escandallo) * parseFloat(sub.precioCompra / (1 + sub.iva / 100)) * parseFloat(sub.dto) / 100)
                                            : total += sub.diferenciaUnidades * parseFloat(sub.precioCompra / (1 + sub.iva / 100)) -
                                            (sub.diferenciaUnidades * parseFloat(sub.precioCompra / (1 + sub.iva / 100)) * parseFloat(sub.dto) / 100);
                                    }
                                } else {
                                    sub.escandallo > 0
                                        ? total += (sub.unidades + sub.partes / sub.escandallo) * parseFloat(sub.precioCompra / (1 + sub.iva / 100)) -
                                        ((sub.unidades + sub.partes / sub.escandallo) * parseFloat(sub.precioCompra / (1 + sub.iva / 100)) * parseFloat(sub.dto) / 100)
                                        : total += sub.unidades * parseFloat(sub.precioCompra / (1 + sub.iva / 100)) -
                                        (sub.unidades * parseFloat(sub.precioCompra / (1 + sub.iva / 100)) * parseFloat(sub.dto) / 100);
                                }
                            }
                        });
                    }
                });
            }
            return total;
        },

        calculateNegativeValues() {

            let total = 0;
            let vm = this;

            if (this.listSubproduct && Array.isArray(this.listSubproduct)) {
                this.listSubproduct.forEach(function (xcat) {
                    if (xcat && xcat.subproducts && Array.isArray(xcat.subproducts)) {
                        xcat.subproducts.forEach(function (sub) {
                            if (sub && sub.precioCompra != null && sub.iva != null) {
                                if (vm.detalles && vm.detalles.tipo === 'I') {
                                    if (sub.diferenciaUnidades < 0 || sub.diferenciaPartes < 0) {
                                        sub.escandallo > 0
                                            ? total += (sub.diferenciaUnidades + sub.diferenciaPartes / sub.escandallo) * parseFloat(sub.precioCompra / (1 + sub.iva / 100))
                                            : total += sub.diferenciaUnidades * parseFloat(sub.precioCompra / (1 + sub.iva / 100));
                                    }
                                } else {
                                    if (sub.unidades < 0 || sub.partes < 0) {
                                        sub.escandallo > 0
                                            ? total += (sub.unidades + sub.partes / sub.escandallo) * parseFloat(sub.precioCompra / (1 + sub.iva / 100))
                                            : total += sub.unidades * parseFloat(sub.precioCompra / (1 + sub.iva / 100));
                                    }
                                }
                            }
                        });
                    }
                });
            }
            return total;
        },


        urlExportPDF() {
            return this.$store.getters.apiUrl + "/almacen/exportHistorialAlmacen/PDF?idBusiness=" + this.idBusiness + "&datefrom=" + moment(this.datefrom).unix() + "&dateto=" + moment(this.dateto).unix() + "&idAlmacen=" + this.idAlmacen + "&jwt=" + this.$store.getters.jwt
            // return "../api/public/index.php/sales/exportCierreCaja/PDF?idBusiness=" + this.idBusiness + "&idAlmacen" + this.idAlmacen + "&jwt=" + this.$store.getters.jwt
            // return "../api/public/index.php/almacen/exportHistorialAlmacen/PDF?idBusiness=" + this.idBusiness + "&datefrom=" + moment(this.datefrom).unix() + "&dateto=" + moment(this.dateto).unix() + "&idAlmacen=" + this.idAlmacen + "&jwt=" + this.$store.getters.jwt
        },
        urlExportExcel() {
            return this.$store.getters.apiUrl + "/almacen/exportHistorialAlmacen/Excel?idBusiness=" + this.idBusiness + "&datefrom=" + moment(this.datefrom).unix() + "&dateto=" + moment(this.dateto).unix() + "&idAlmacen=" + this.idAlmacen + "&jwt=" + this.$store.getters.jwt
            // return "../api/public/index.php/sales/exportCierreCaja/Excel?idBusiness=" + this.idBusiness + "&idAlmacen" + this.idAlmacen + "&jwt=" + this.$store.getters.jwt
            // return "../api/public/index.php/almacen/exportHistorialAlmacen/Excel?idBusiness=" + this.idBusiness + "&datefrom=" + moment(this.datefrom).unix() + "&dateto=" + moment(this.dateto).unix() + "&idAlmacen=" + this.idAlmacen + "&jwt=" + this.$store.getters.jwt
        },
    },
    methods: {

        getInventario() {
            var config = {
                params: {
                    jwt: this.$store.getters.jwt,
                    idAlmacen: this.idAlmacen,
                    idBusiness: this.idBusiness,
                },
                headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
            };

            let vm = this;
            this.axios.get(this.$store.getters.apiUrl + "almacen/getInventario", config)
                .then(function (response) {

                    if (response.data.response) {

                        vm.listSubproduct = response.data.result.inventario.elements;
                        vm.detalles = response.data.result.inventario

                    } else {


                    }


                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        getTotalValor(s) {
            let total = 0;
            let vm = this;

            if (s && s.subproducts && Array.isArray(s.subproducts)) {
                s.subproducts.forEach(function (sub) {
                    if (sub && sub.precioCompra != null && sub.iva != null) {
                        if (vm.detalles && vm.detalles.tipo === 'I') {
                            if (sub.diferenciaUnidades > 0 || sub.diferenciaPartes > 0) {
                                sub.escandallo > 0
                                    ? total += (sub.diferenciaUnidades + sub.diferenciaPartes / sub.escandallo) * parseFloat(sub.precioCompra / (1 + sub.iva / 100))
                                    : total += sub.diferenciaUnidades * parseFloat(sub.precioCompra / (1 + sub.iva / 100));
                            }
                        } else {
                            sub.escandallo > 0
                                ? total += (sub.unidades + sub.partes / sub.escandallo) * parseFloat(sub.precioCompra / (1 + sub.iva / 100))
                                : total += sub.unidades * parseFloat(sub.precioCompra / (1 + sub.iva / 100));
                        }
                    }
                });
            }

            return total;
        },
        getTotalValorDto(s) {
            let total = 0;
            let vm = this;

            if (s && s.subproducts && Array.isArray(s.subproducts)) {
                s.subproducts.forEach(function (sub) {
                    if (sub && sub.precioCompra != null && sub.iva != null && sub.dto != null) {
                        if (vm.detalles && vm.detalles.tipo === 'I') {
                            if (sub.diferenciaUnidades > 0 || sub.diferenciaPartes > 0) {
                                if (sub.escandallo > 0) {
                                    total += (sub.diferenciaUnidades + sub.diferenciaPartes / sub.escandallo) * parseFloat(sub.precioCompra / (1 + sub.iva / 100)) -
                                        ((sub.diferenciaUnidades + sub.diferenciaPartes / sub.escandallo) * parseFloat(sub.precioCompra / (1 + sub.iva / 100)) * parseFloat(sub.dto) / 100);
                                } else {
                                    total += sub.diferenciaUnidades * parseFloat(sub.precioCompra / (1 + sub.iva / 100)) -
                                        (sub.diferenciaUnidades * parseFloat(sub.precioCompra / (1 + sub.iva / 100)) * parseFloat(sub.dto) / 100);
                                }
                            }
                        } else {
                            if (sub.escandallo > 0) {
                                total += (sub.unidades + sub.partes / sub.escandallo) * parseFloat(sub.precioCompra / (1 + sub.iva / 100)) -
                                    ((sub.unidades + sub.partes / sub.escandallo) * parseFloat(sub.precioCompra / (1 + sub.iva / 100)) * parseFloat(sub.dto) / 100);
                            } else {
                                total += sub.unidades * parseFloat(sub.precioCompra / (1 + sub.iva / 100)) -
                                    (sub.unidades * parseFloat(sub.precioCompra / (1 + sub.iva / 100)) * parseFloat(sub.dto) / 100);
                            }
                        }
                    }
                });
            }

            return total;
        },


    },
    created() {

        this.getInventario();

    }
}
</script>

<style scoped>
.card {
    padding: 20px;
}

.div-export {
    margin-bottom: 10px;
}
</style>


// WEBPACK FOOTER //
// src/pages/Dashboard/Almacen/DetallesAlmacen.vue